module.exports = __webpack_public_path__ + "01_long_black.5f88e0a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/01_long_black.png
// module id = toCt
// module chunks = 0